import { render } from "./SlidesCate.vue?vue&type=template&id=76039eca&scoped=true"
import script from "./SlidesCate.vue?vue&type=script&lang=js"
export * from "./SlidesCate.vue?vue&type=script&lang=js"

import "./SlidesCate.vue?vue&type=style&index=0&id=76039eca&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76039eca"]])

export default __exports__